module.exports = __webpack_public_path__ + "media/images/errors/process_closed-31203c9b75e6e9de632fdbd4695f8742.png";